import ApiClient from './ApiClient';

class PhoneCentralConfigsAPI extends ApiClient {
  constructor() {
    super('phone_central_configs', { accountScoped: true });
  }

  getCallLogs({ page = 1, since, until: untilDate, inboxId } = {}) {
    const params = new URLSearchParams();
    params.append('page', page);
    if (since) params.append('since', since);
    if (untilDate) params.append('until', untilDate);
    if (inboxId) params.append('inbox_id', inboxId);
    return axios.get(`${this.url}/call_logs?${params.toString()}`);
  }
}

export default new PhoneCentralConfigsAPI();
